// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3NSzp","author":"Table_author__q5Ton","authorImage":"Table_authorImage__332nP","unreadRow":"Table_unreadRow__3f3a7"};